function isVisible(el) {
    var rect = el.getBoundingClientRect(), top = rect.top, height = rect.height,
        el = el.parentNode;
    do {
        rect = el.getBoundingClientRect();
        if (!(top <= rect.bottom)) return false;
        if ((top + height) <= rect.top) return false
        el = el.parentNode;
    } while (el !== document.body);
    return top <= document.documentElement.clientHeight;
}

function animation(el, isModal = false) {
    if (!isVisible(el) && !isModal) {
        el.scrollIntoView({behavior: 'smooth'})
    }

    if (el.offsetWidth > el.offsetHeight) {
        el.setAttribute('style', 'animation: shake-soft 0.9s; ') // table
    } else {
        el.setAttribute('style', 'animation: shake 0.9s; animation-iteration-count: 5;') // info
    }

    setTimeout(() => { el.removeAttribute('style') }, 200)
}

export { animation }
